<template>
  <div>

    <el-dialog :title="`支付页${details.id ? '编辑' : '新增'}`"
               :visible.sync="addDialogVisible"
               width="60%"
               append-to-body
               :before-close="handleClose">
      <el-form :model="ruleForm"
               :rules="formRules"
               ref="ruleForm"
               label-width="120px"
               class="ruleForm">
        <div class="title">基础配置</div>
        <div class="content">
          <el-form-item label="会员类型："
                        prop="memberTypeIdListId">
            <el-select v-model="ruleForm.memberTypeIdListId"
                       @change="()=>{
                        ruleForm.memberTypeIdList = getObjectsWithSameId(ruleForm.memberTypeIdListId, defaultMemberTypeIdOption)
                        // 如果列表里面没有默认选中的id,需要把ruleForm.defaultMemberTypeId 清空
                        if (!ruleForm.memberTypeIdList.find(item => item.id == ruleForm.defaultMemberTypeId) || item.memberTypeId == ruleForm.defaultMemberTypeId) {
                          ruleForm.defaultMemberTypeId = ''
                        }
                      }"
                       multiple
                       placeholder="请选择会员类型">
              <el-option v-for="(item,index) in defaultMemberTypeIdOption"
                         :key="index"
                         :label="`(${item.id}) ${getMemberTypeName(item.type)}-${item.name}-${item.saleStatus === 1 ? '在售' : '停售'}`"
                         :value="+item.id"></el-option>

            </el-select>
          </el-form-item>
          <el-table :data="ruleForm.memberTypeIdList"
                    border
                    style="width: 100%">
            <el-table-column type="index"
                             label="No"
                             width="45">
            </el-table-column>

            <el-table-column prop="name"
                             label="会员类型">
            </el-table-column>
            <el-table-column prop="defaultMemberTypeId"
                             label="选中状态">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text"
                           @click="moveItemUp(ruleForm.memberTypeIdList, scope.row)">上移</el-button>
                <el-button type="text"
                           @click="moveItemDown(ruleForm.memberTypeIdList, scope.row)">下移</el-button>
                <el-button type="text"
                           @click="defaultSelection( scope.row.memberTypeId, ruleForm.memberTypeIdList)">默认选中</el-button>
              </template>

            </el-table-column>
          </el-table>

        </div>
        <div class="title">命中配置</div>
        <div class="content">
          <el-form-item label="入口来源："
                        prop="paySourceKeyList">
            <el-select v-model="ruleForm.paySourceKeyList"
                       multiple
                       placeholder="请选择入口来源">
              <el-option :label="item.name + ' - ( ' + item.sourceKey + ' )'"
                         v-for="(item,index) in paySourceListOptions"
                         :key="index"
                         :value="item.sourceKey"></el-option>

            </el-select>
            <el-button type="primary"
                       style="margin-left: 12px;"
                       @click="innerVisible = true"
                       size="small">创建入口来源</el-button>
          </el-form-item>
          <el-form-item label="渠道选择："
                        prop="channelType">
            <el-radio-group v-model="ruleForm.channelType"
                            @change="()=>{ruleForm.channelName=''}">
              <el-radio label="0">全部渠道</el-radio>
              <el-radio label="1">指定渠道</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="ruleForm.channelType != '0'"
                        label="">
            <el-input type="textarea"
                      @focus="handleClick()"
                      v-model="ruleForm.channelName">
            </el-input>
          </el-form-item>
          <el-form-item label="TV端版本号：" prop="tvVersionType">
            <el-radio-group v-model="ruleForm.tvVersionType">
              <el-radio
                v-for="item in versionTypeOptions"
                :key="item.value"
                :label="item.value"
              >{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="ruleForm.tvVersionType === VERSION_TYPE.INTERVAL">
            <div>
              <div class="tv-version-input">
                <el-form-item prop="tvVersionMin" label="最小版本号(>=):">
                  <el-input
                    v-model="ruleForm.tvVersionMin"
                    placeholder="输入TV版本号,整数输入,如808081912"
                  ></el-input>
                </el-form-item>
                <el-form-item prop="tvVersionMax" label="最大版本号(<=):">
                  <el-input
                    v-model="ruleForm.tvVersionMax"
                    placeholder="输入TV版本号,整数输入,如808081912"
                  ></el-input>
                </el-form-item>
              </div>
              <el-form-item label="特殊版本命中：" prop="regexTvVersion">
                <el-input v-model="ruleForm.regexTvVersion" style="width: 452px" placeholder="支持输入正则表达式"></el-input>
              </el-form-item>
            </div>
          </template>
          <template v-else-if="ruleForm.tvVersionType === VERSION_TYPE.SPECIFIC">
            <el-form-item prop="tvVersionSpecified">
              <el-input
                v-model="ruleForm.tvVersionSpecified"
                type="textarea"
                placeholder="请输入指定版本号，多个用英文逗号隔开"
              ></el-input>
            </el-form-item>
          </template>
        </div>
        <div class="title">
          <span class="text">挽留弹窗配置</span>
          <el-button type="primary" size="small" @click="createPop">创建挽留弹窗</el-button>
        </div>
        <div class="content" v-for="(item, index) in ruleForm.ruleList" :key="index" style="margin-bottom: 20px">
          <div>
            <span class="subTitle">规则{{ index + 1 }}</span>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="deleteRule(index)">删除</el-button>
          </div>
          <el-form-item label="弹窗样式：" :prop="`ruleList[${index}].style`">
            <el-radio-group v-model="item.style">
              <el-radio label="1">文案挽留</el-radio>
              <el-radio label="2">折扣商品挽留</el-radio>
              <el-radio label="3">优惠券挽留</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="主标题：" v-if="item.style === '1'" :prop="`ruleList[${index}].title`">
            <el-input v-model="item.title" style="width: 400px;" placeholder="请输入主标题"></el-input>
          </el-form-item>
          <el-form-item label="副标题：" v-if="item.style === '1'" :prop="`ruleList[${index}].subTitle`">
            <el-input v-model="item.subTitle" style="width: 400px;" placeholder="请输入副标题"></el-input>
          </el-form-item>
          <el-form-item label="上传图片：" v-if="item.style !== '1'" :prop="`ruleList[${index}].imgUrl`" :ref="`upload${index}`">
            <el-upload
            action="#"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :auto-upload="false"
              :file-list="item.fileList"
              :on-change="(file, file_list)=>{return handleChangeImgs(file, file_list, item, index)}"
              :on-remove="(file, file_list)=>{return handleRemoveImgs(file, file_list, item)}"
              :limit="1"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>
          <el-form-item :prop="`ruleList[${index}].goodId`" label="指定商品：" v-if="item.style === '2'">
            <el-cascader
              style="width: 400px;"
              :options="initData.memberGoods"
              collapse-tags
              clearable
              size="small"
              separator="-"
              v-model="item.goodId"
            >
            </el-cascader>
          </el-form-item>
          <el-form-item label="指定优惠券：" v-if="item.style === '3'" :prop="`ruleList[${index}].couponId`">
            <el-select v-model="item.couponId" placeholder="请选择指定优惠券">
              <el-option v-for="item in couponList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="触发场景：" :prop="`ruleList[${index}].triggerScene`">
            <el-select v-model="item.triggerScene" placeholder="请选择触发场景">
              <el-option label="打开会员支付页时弹出" :value="1">
              </el-option>
              <el-option label="未支付成功返回支付页" :value="2">
              </el-option>
              <el-option label="支付停留30s未发起支付" :value="3">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指定用户：" :prop="`ruleList[${index}].limitType`">
            <el-radio-group v-model="item.limitType">
              <el-radio label="1">全部用户</el-radio>
              <el-radio label="2">指定标签</el-radio>
              <el-radio label="3">指定用户</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 根据用户类型不同而改变 -->
        <template v-if="item.limitType == '2'">
          <el-form-item
            label="指定标签："
            :prop="`ruleList[${index}].userTags`"
          >
            <!-- 下拉选择 -->
            <el-select
              style="width: 300px"
              v-model="item.userTags"
              placeholder="请选择标签"
              multiple
              collapse-tags
            >
              <el-option
                v-for="item in userTagOptions"
                :key="item.id"
                :label="item.tag"
                :value="item.tag"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <template v-if="item.limitType == '3'">
          <el-form-item
            label="指定账号："
            :prop="`ruleList[${index}].phones`"
          >
            <div style="display: flex">
              <el-button @click="downTemplate" type="primary" size="small"
                >下载模板</el-button
              >
              <el-upload
                :show-file-list="false"
                :before-upload="beforeUpload"
                :http-request="(v) => importExcel(item, v)"
                :multiple="false"
              >
                <el-button style="margin-left: 10px" type="primary" size="small"
                  >导入</el-button
                >
              </el-upload>

              <span
                style="
                  margin-left: 10px;
                  cursor: pointer;
                  color: #409eff;
                  text-decoration: underline;
                  margin-right: 10px;
                "
                @click="downPhoneFile(item)"
                >{{ item.userMobileFileName }}</span
              >
              <el-button
                @click="delPhoneFile(item)"
                type="text"
                size="small"
                >删除</el-button
              >
            </div>
          </el-form-item>
        </template>
        </div>
      </el-form>

      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="submitForm" :loading="isLoading">确 定</el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>

    </el-dialog>
    <el-dialog width="40%"
               title="创建入口来源"
               :visible.sync="innerVisible"
               append-to-body>

      <el-form :model="innerRuleForm"
               :rules="innerRules"
               ref="innerRuleForm"
               label-width="100px"
               class="innerRuleForm">

        <div class="title">基础配置</div>
        <div class="content">
          <el-form-item label="入口命名："
                        prop="name">
            <el-input v-model="innerRuleForm.name"
                      :maxlength="99"
                      placeholder="请输入入口命名"></el-input>
          </el-form-item>
          <el-form-item label="Key值："
                        prop="sourceKey">
            <el-input v-model="innerRuleForm.sourceKey"
                      :maxlength="99"
                      placeholder="请输入Key值"></el-input>
          </el-form-item>
        </div>

      </el-form>
      <span slot="footer"
            class="dialog-footer">
        <el-button type="primary"
                   @click="handlePaySourceSave" >确 定</el-button>
        <el-button @click="innerVisible = false">取 消</el-button>
      </span>
    </el-dialog>
    <channel-popups :app-id="ruleForm.channelId"
                    :visible.sync="showPopups"
                    @comfirm="handleConfirm"></channel-popups>
    <el-dialog :visible.sync="dialogVisible" append-to-body>
      <img width="100%" :src="imgUrl"/>
    </el-dialog>
  </div>
</template>

<script>
import { putFile } from '@/api/app'
import { paySourceList, paySourceSave, typeListByType, configSave, configUpdate, getDetail } from '@/api/memberNew/paymentPageConfig'
import ChannelPopups from "@/components/channel-popups";
import Message from "@/components/Message";
import moment from "moment";
import { getMemberGoods } from "@/api/memberNew/memberUnite";
import { getBigDataTags } from "@/api/runActivityManage/activity";
import { importPhoneList, downloadPhoneFile } from "@/api/memberNew/paymentPageConfig";
import { tvVersionHandle, tvVersionJoinHandler, VERSION_TYPE, VERSION_TYPE_LIST } from "./utils/useTvVersion"
import axios from "axios";
import { get_coupon_list } from '@/api/coupon/index'
import { getMemberType } from "@/api/memberNew/memberType";
export default {
  components: {
    ChannelPopups,
  },
  props: {
    addDialogVisible: {
      type: Boolean,
      default: true
    },
    details: {
      type: Object,
      default: () => { }
    }
  },
  data () {
    return {
      /** 是否loading */
      isLoading: false,
      paySourceListOptions: [], //入口来源选项
      defaultMemberTypeIdOption: [], // 会员选项
      versionTypeOptions: VERSION_TYPE_LIST,
      /** 渠道选择框的显隐 */
      showPopups: false,
      innerVisible: false,
      ruleForm: {
        channelId: '',
        channelName: '',
        defaultMemberTypeId: '',
        memberTypeIdList: [],
        paySourceKeyList: '',
        ruleList: [],
        tvVersionType: VERSION_TYPE.ALL,
        tvVersionMin: "",
        tvVersionMax: "",
        tvVersionSpecified: "",
        regexTvVersion: ""
      },
      innerRuleForm: {},
      innerRules: {
        name: [
          { required: true, message: '请输入入口命名', trigger: 'blur' },
        ],
        sourceKey: [
          { required: true, message: '请输入Key值', trigger: 'blur' },
        ],
      },
      couponList: [],
      initData: {
        /** 关联乐播会员商品 */
        memberGoods: [],
        /** 会员商品map */
        memberGoodsMap: []
      },
      dialogVisible: false,
      imgUrl: '',
      /** 会员类别 */
      memberTypeList: [],
    };
  },
  watch: {
    addDialogVisible (val) {
      if (val) {
        this.init();
      }
    }
  },
  created () {
    this.getUserTagOptions()
    this.getMemberGoods()
    this.get_coupon_list()
    this.getMemberType()
  },
  computed: {
    VERSION_TYPE() {
      return VERSION_TYPE
    },
    formRules () {
      const rules = {
        channelType: [
          { required: true, message: '请选择渠道', trigger: 'change' }
        ],
        tvVersionType: [
          { required: true, message: '请选择tv版本号', trigger: 'change' }
        ],
        tvVersionMin: [
          {
            validator: this.tvVersionValidator,
            trigger: ["change", "blur"],
          },
        ],
        tvVersionMax: [
          {
            validator: this.tvVersionValidator,
            trigger: ["change", "blur"],
          },
        ],
        regexTvVersion: [
          {
            validator: this.tvVersionValidator,
            trigger: ["change", "blur"],
          },
        ],
        tvVersionSpecified: [
          {
            validator: this.tvVersionValidator,
            trigger: ["change", "blur"],
          },
        ],
        paySourceKeyList: [
          { required: true, message: '请选择入口来源', trigger: 'change' }
        ],
        memberTypeIdListId: [
          { required: true, message: '请选择会员类型', trigger: 'change' }
        ],
        ruleList: this.ruleForm.ruleList.reduce((rules, _, key) => {
          const index = key + 1;
          rules[key] = {
            style: {
              ruleTip: `请选择规则${index}的弹窗样式`,
              required: true,
              message: "请选择弹窗样式",
              trigger: ["blur", "change"],
            },
            title: {
              ruleTip: `请输入规则${index}的主标题`,
              required: true,
              message: "请输入主标题",
              trigger: ["blur", "change"],
            },
            subTitle: {
              ruleTip: `请输入规则${index}的副标题`,
              required: true,
              message: "请输入副标题",
              trigger: ["blur", "change"],
            },
            imgUrl: {
              required: true,
              message: "请上传图片",
              trigger: ["change"],
              validator: (rule, value, callback) => {
                if (!_.imgUrl) {
                  callback(new Error("请上传图片"));
                } else {
                  callback();
                }
              }
            },
            goodId: {
              ruleTip: `请选择规则${index}的指定商品`,
              required: true,
              message: "请选择指定商品",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!_.goodId) {
                  callback(new Error("请选择指定商品"));
                } else {
                  callback();
                }
              }
            },
            limitType: {
              ruleTip: `请选择规则${index}的指定用户`,
              required: true,
              message: "请选择指定用户",
              trigger: ["blur", "change"],
            },
            userTags: {
              type: "array",
              ruleTip: `请选择活动规则${index}的用户标签`,
              required: true,
              message: "请选用户标签",
              trigger: ["blur", "change"],
            },
            couponId: {
              ruleTip: `请选择规则${index}的指定优惠券`,
              required: true,
              message: "请选择指定优惠券",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!_.couponId) {
                  callback(new Error("请选择指定商品"));
                } else {
                  callback();
                }
              }
            },
            phones: {
              ruleTip: `请填写活动规则${index}的用户手机号`,
              required: true,
              message: "请上传用户手机号",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!_.phones.length) {
                  callback(new Error("请选择指定商品"));
                } else {
                  callback();
                }
              }
            },
            triggerScene: {
              ruleTip: `请选择规则${index}的触发场景`,
              required: true,
              message: "请选择触发场景",
              trigger: ["blur", "change"],
              validator: (rule, value, callback) => {
                if (!_.triggerScene) {
                  callback(new Error("请选择触发场景"));
                } else {
                  callback();
                }
              }
            }
          }
          return rules;
        }, {}),
      }
      return rules;
    }
  },
  methods: {
    //^ ^--------------初始化数据-------------^ ^
    // 获取优惠券list
    async get_coupon_list () {
      const { data } = await get_coupon_list();
      this.couponList = data.data
    },
    /** 获取会员类别 */
    async getMemberType() {
      const { data } = await getMemberType();
      this.memberTypeList = data.data.records.map(item => ({
        label: item.dictValue,
        value: item.dictKey
      }))
    },
    /** 获取会员类别的名称 */
    getMemberTypeName(type) {     
      const res = this.memberTypeList.find(item => item.value === type)
      
      return res ? res.label : ''
    },
    /** 获取以会员类型分组所有的会员商品 */
    async getMemberGoods() {
      const { data } = await getMemberGoods();
      console.log("获取以会员类型分组所有的会员商品接口的响应", data);
      this.initData.memberGoods = data.data.map(item => ({
        value: item.memberTypeId,
        label: item.memberTypeName,
        children: item.memberGoodsVOList.length > 0 ? item.memberGoodsVOList.map(goods => ({
          value: goods.id,
          label: goods.goodsName + '-' + goods.salePrice + '元'
        })) : null
      }))
      console.log("this.initData.memberGoods", this.initData.memberGoods);
      /** 会员商品map */
      this.initData.memberGoodsMap = new Map();
      this.initData.memberGoods.forEach((item) => {
        item.children.forEach((i) => {
          this.initData.memberGoodsMap.set(i.value, i.label);
        });
      });
    },
    /** 获取大数据用户标签 */
    async getUserTagOptions() {
      const { data } = await getBigDataTags();
      console.log("获取大数据用户标签的响应", data);
      this.userTagOptions = data.data;
    },
    // 上移
    moveItemUp (array, currentItem) {
      const currentIndex = array.indexOf(currentItem);
      if (currentIndex > 0) {
        const previousIndex = currentIndex - 1;
        array.splice(previousIndex, 2, currentItem, array[previousIndex]);
      }
    },
    // 下移
    moveItemDown (array, currentItem) {
      const currentIndex = array.indexOf(currentItem);
      if (currentIndex < array.length - 1) {
        const nextIndex = currentIndex + 1;
        array.splice(currentIndex, 2, array[nextIndex], currentItem);
      }
    },
    // 默认选中
    defaultSelection (id, arr = []) {
      let list = arr.map(item => {
        return {
          ...item,
          defaultMemberTypeId: ''
        }
      })
      list.forEach((item) => {
        if (item.memberTypeId === id) {
          item.defaultMemberTypeId = '选中状态'
        }
      })
      this.ruleForm.memberTypeIdList = list
      this.ruleForm.defaultMemberTypeId = id
    },
    // 会员类型多选方法
    getObjectsWithSameId (idArray, objectArray) {
      let result = [];

      for (let i = 0; i < idArray.length; i++) {
        let id = idArray[i];

        for (let j = 0; j < objectArray.length; j++) {
          let obj = objectArray[j];

          if (obj.id == id) {
            result.push(obj);
            break;
          }
        }
      }

      return result;
    }
    ,
    /** 渠道选择框 */
    handleClick () {
      this.showPopups = true;
    },
    /** 确认渠道选择 */
    handleConfirm (data) {
      console.log("渠道选择的数据", data);
      const { appId, nameStr, isAll } = data;
      if (isAll) {
        this.ruleForm.channelType = '0'
      } else {
        this.ruleForm.channelId = appId;
        this.ruleForm.channelName = nameStr;
      }

    },
    // 初始化页面数据
    async init () {
      try {
        let paySourceListData = await paySourceList()
        this.paySourceListOptions = paySourceListData.data.data || []
        // 获取会员类型列表，type传递0和5，代表获取新会员和企业会员类型
        let typeListByTypeData = await typeListByType({ type: '0,5' })
        this.defaultMemberTypeIdOption = typeListByTypeData.data || []
        this.defaultMemberTypeIdOption = this.defaultMemberTypeIdOption.map(item => { return { ...item, memberTypeId: item.id } })

        this.ruleForm = {
          channelId: '',
          channelName: '',
          defaultMemberTypeId: '',
          memberTypeIdList: [],
          paySourceKeyList: '',
          ruleList: [],
          tvVersionType: VERSION_TYPE.ALL,
          tvVersionMin: "",
          tvVersionMax: "",
          tvVersionSpecified: "",
          regexTvVersion: ""
        }
        this.$refs['ruleForm'].resetFields()

        if (this.details.id) {
          let res = await getDetail({ memberPayConfigId: this.details.id })
          let data = {
            memberTypeIdListId: res.data.data.memberPayConfigTypeList.map(item => +item.memberTypeId),
            memberTypeIdList: res.data.data.memberPayConfigTypeList.map(item => { return { ...item, name: item.memberTypeName } }),
            defaultMemberTypeId: res.data.data.defaultMemberTypeId,
            paySourceKeyList: res.data.data.memberPayConfigSourceList.map(item => item.paySourceKey),
            channelId: res.data.data.memberPayConfigChannelList.map(item => item.channelId),
            channelName: res.data.data.memberPayConfigChannelList.map(item => item.channelName),
            tvVersionType: res.data.data.tvVersionType || VERSION_TYPE.ALL,
            id: res.data.data.id
          }
          let memberPayConfigPopupList = res.data.data.memberPayConfigPopupList
          // 挽留弹窗
          memberPayConfigPopupList.map((item) => {
            item.style = item.style.toString()
            item.limitType = item.limitType.toString()
            item.fileList = [{url: item.imgUrl}]
            if (item.goodId) {
              let memberGoods = this.initData.memberGoods.filter((ele)=>{
                return ele.children && ele.children.some((subEle)=>{
                  return subEle.value === item.goodId
                })
              })
              item.goodId = [memberGoods[0].value, item.goodId]
            }
            item.userTags = item.userTags.split(",");
            if (item.phones) {
              item.userMobileFileName = '用户手机文件'
            }
          })
          data.ruleList = memberPayConfigPopupList
          data.channelType = data.channelId.length && data.channelId[0] == '0' ? '0' : '1',
          data.channelId = Array.isArray(data.channelId) && data.channelId.length ? data.channelId.join(',') : ''
          data.channelName = Array.isArray(data.channelName) && data.channelName.length ? data.channelName.join(',') : ''
          this.ruleForm = {
            ...data,
            ...tvVersionHandle(data.tvVersionType, res.data.data.tvVersion, res.data.data.regexTvVersion)
          }
          this.$forceUpdate()
          this.defaultSelection(this.ruleForm.defaultMemberTypeId, this.ruleForm.memberTypeIdList)
        }
      } catch (error) {
        this.paySourceListOptions = []
        this.defaultMemberTypeIdOption = []
      }
    },
    // 新增支付入口来源
    async handlePaySourceSave () {
      this.$refs['innerRuleForm'].validate(async (valid) => {
        if (valid) {
          let { data } = await paySourceSave(this.innerRuleForm)
          if (data.code == 200) {
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
            this.innerRuleForm = {}
            let paySourceListData = await paySourceList()
            this.paySourceListOptions = paySourceListData.data.data || []
            this.innerVisible = false
          }

        } else {
          return false;
        }
      });

    },

    /**
     * tv版本号相关校验
     * 版本号只能是数字，并且最小版本号不能大于最大版本号
     */
    tvVersionValidator(rule, value, callback) {
      const type = this.ruleForm.tvVersionType;
      const min = this.ruleForm.tvVersionMin;
      const max = this.ruleForm.tvVersionMax;
      const regexVer = this.ruleForm.regexTvVersion;
      const specified = this.ruleForm.tvVersionSpecified;

      // 验证区间版本号
      const validateIntervalVersion =  () => {
        // 两个版本号和特殊版本都没填
        if ((!min || min === "") && (!max || max === "") && (!regexVer || regexVer === "")) {
          return new Error("请填写版本号 / 特殊版本");
        }
        // 只能输入数字
        if (min && !/^\d+$/.test(min)) {
          return new Error("最小版本号只能输入数字");
        }
        if (max && !/^\d+$/.test(max)) {
          return new Error("最大版本号只能输入数字");
        }
        // 最小版本号不能大于最大版本号
        if (min && max && (+min > +max)) {
          return new Error("最大版本号需要大于最小版本号");
        }
      };

      // 验证特殊版本号
      const validateSpecificVersion = () => {
        // 只能输入数字和英文逗号
        if (!specified || specified === "") {
          return new Error("请输入指定版本号");
        }
        if (!/^\d+(,\d+)*$/.test(specified)) {
          return new Error("多个版本号用英文逗号隔开");
        }
      };

      // 验证区间版本号
      if (type === VERSION_TYPE.INTERVAL) {
        callback(validateIntervalVersion());
      } else if (type === VERSION_TYPE.SPECIFIC) {
        // 验证特殊版本号
        callback(validateSpecificVersion());
      } else {
        callback();
      }
    },
    //提交表单
    async submitForm () {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
          let params = {
            channalList: [],
            defaultMemberTypeId: this.ruleForm.defaultMemberTypeId,
            memberTypeIdList: this.ruleForm.memberTypeIdList.map(item => { return item.memberTypeId || item.id }),
            paySourceKeyList: this.ruleForm.paySourceKeyList,
            popupList: [],
            tvVersionType: this.ruleForm.tvVersionType,
            // tv版本号处理
            ...tvVersionJoinHandler(this.ruleForm)
          }
          // 默认选中会员如果没选，默认第一个
          if (!params.defaultMemberTypeId) {
            params.defaultMemberTypeId = params.memberTypeIdList[0]
          }
          // 渠道数据  处理成后端需要的格式
          if (this.ruleForm.channelType == '0') {
            params.channalList = [
              {
                channelId: '0',
                channelName: '全部渠道'
              }
            ]
          } else if (this.ruleForm.channelId) {
            let channelId = this.ruleForm.channelId.split(',')
            let channelName = this.ruleForm.channelName.split(',')
            channelId.forEach((item, index) => {
              params.channalList.push({
                channelId: channelId[index],
                channelName: channelName[index]
              })
            })
          } else {
            this.$message({
              type: 'info',
              message: '渠道不能为空！'
            });
            return
          }
          let arr = []
          // 挽留弹窗数据组装
          this.ruleForm.ruleList.forEach((item) => {
            let obj = {}
            obj.style = item.style
            obj.limitType = item.limitType
            obj.triggerScene = item.triggerScene
            // 弹窗样式
            if (item.style === '1') {
              obj.title = item.title
              obj.subTitle = item.subTitle
            } else if (item.style === '2') {
              obj.imgUrl = item.imgUrl
              obj.goodId = item.goodId[item.goodId.length-1]
            } else if (item.style === '3') {
              obj.imgUrl = item.imgUrl
              obj.couponId = item.couponId
            }
            // 指定用户
            if (item.limitType === '2') {
              obj.userTags = item.userTags.join(',')
            } else if (item.limitType === '3') {
              obj.phones = item.phones
            }
            arr.push(obj)
          })
          params.popupList = arr
          // 有id就是编辑
          if (this.ruleForm.id) {
            params.id = this.ruleForm.id
          }
          try {
            let api = params.id ? configUpdate : configSave
            this.isLoading = true
            let { data } = await api(params)
            if (data.code == 200) {
              this.isLoading = false
              this.$message({
                type: 'success',
                message: '操作成功!'
              });
              this.handleClose()
            }
          } catch (error) {
            this.isLoading = false
          }
        } else {
          return false;
        }
      });

    },
    //关闭页面
    handleClose () {
      this.$emit('closeDialogVisible', false)
    },
    // 删除上传的图片
    handleRemoveImgs(file, fileList, item) {
      item.imgUrl = ''
      item.fileList = []
    },
    // 上传的图片预览
    handlePictureCardPreview(file) {
      this.imgUrl = file.url;
      this.dialogVisible = true;
    },
    //上传图片
    handleChangeImgs(file, fileList, item, index) {
      const isPic = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'].includes(file.raw.type);
      const isLt2M = file.size / 1024 / 1024 < 5;
      // 指定jpg png格式
      if (!isPic || !isLt2M) {
        this.$message.error(!isPic ? '上传图片只能是 JPG/PNG 格式!' : '上传图片大小不能超过 5MB!');
        item.fileList = []
        this.$forceUpdate()
        return
      }
      item.fileList = [fileList[fileList.length - 1]]
      const formData = new FormData()
      formData.append('file', file.raw)
      putFile(formData).then((res) => {
        if (res.data.code === 200) {
          item.imgUrl = res.data.data.link
          this.$refs[`upload${index}`][0].clearValidate();
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    /** 下载用户手机号导入模板 */
    downTemplate() {
      axios({
        method: "get",
        url:
          process.env.VUE_APP_BASE_URL +
          `/lebo-member/web/member/config/exportPhone-template`,
        responseType: "blob",
      }).then((res) => {
        var blob = res.data; //blob对象
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
          const a = document.createElement("a");

          a.download = "用户模板.xlsx";

          // a.download = 'UID-excel.xlsx'
          a.href = e.target.result;
          a.click();
        };
      });
    },
    /** 删除手机号文件 */
    delPhoneFile(item) {
      if (!item) {
        Message.error("请先上传手机号文件");
        return;
      }
      item.phones = [];
      item.userMobileFileName = "";
      /** 强制刷新数据 */
      this.ruleForm.ruleList = [...this.ruleForm.ruleList];
      Message.success("删除成功");
    },
    /** 下载手机号文件 */
    async downPhoneFile(item) {
      if (!item.id) {
        return
      }
      const data = await downloadPhoneFile({id: item.id});
      /** 二进制文件 */
      const blob = new Blob([data.data]);

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      // 设置下载文件的名称和扩展名
      a.download = decodeURIComponent(
        "手机号文件_" + moment().format("YYYY-MM-DD") + ".xlsx"
      );
      document.body.appendChild(a);
      a.click();
      // 释放URL对象
      window.URL.revokeObjectURL(url);
      console.log("下载手机号文件的响应", data);
      // window.open(data.data);
    },
    /** 导入用户手机号 */
    importExcel(item, file) {
      console.log("导入用户手机号", file);
      const formData = new FormData();
      formData.append("file", file.file);
      // formData.append("promotionId", this.ruleForm.id);
      importPhoneList(formData).then((res) => {
        console.log("导入用户手机号的响应", res);
        if (res.data.code == 200) {
          item.phones = res.data.data.phones;
          item.userMobileFileName = file.file.name;
          /** 强制刷新数据 */
          this.ruleForm.ruleList = [...this.ruleForm.ruleList];
          Message.success("导入成功");
        }
      });
    },
    // 上传前校验
    beforeUpload(file) {
      const isxlsx = /.xlsx|.xls/.test(file.name);
      if (!isxlsx) {
        Message.error("上传文件只能是 xlsx格式!");
      }
      return isxlsx;
    },
    // 创建弹窗
    createPop () {
      this.ruleForm.ruleList.push({
        style: '1',
        title: '',
        subTitle: '',
        imgUrl: '',
        dialogVisible: false,
        goodId: '',
        limitType: '1',
        userTags: '',
        userMobileFileName: '',
        id: '',
        phones: []
      })
    },
    // 删除
    deleteRule (index) {
      this.ruleForm.ruleList.splice(index, 1)
    }
  }
};
</script>

<style scoped lang="scss">
.ruleForm {
  padding: 0 24px;
}
.title {
  font-size: 18px;
  font-weight: bold;
  padding: 12px;
  .text {
    margin-right: 20px;
  }
}
.content {
  padding: 24px;
  border-radius: 8px;
  background-color: #f2f2f2;
  .el-select {
    min-width: 330px;
  }
  .subTitle {
    margin-right: 100px;
  }

  /deep/ .tv-version-input {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 120px;
    box-sizing: border-box;
    gap: 20px;

    .el-form-item {
      width: 50%;
    }
  }
}
</style>
